<title>{{ apiReferenceXMLSamplesPage.htmlTitle }}</title>
<div class="app-api-reference-xml-samples-page">
  <app-modal id="openFileContent"></app-modal>
  <app-api-reference-note-section *ngIf="isNoteSectionExist" [noteSections]="apiReferenceXMLSamplesPage.noteSections"></app-api-reference-note-section>
  <app-api-reference-introduction-section *ngIf="isSection" [sections]="apiReferenceXMLSamplesPage.introductionSections"></app-api-reference-introduction-section>
  <app-file-assets-table-section [tableSections]="apiReferenceXMLSamplesPage.tableSections"></app-file-assets-table-section>
</div>
